const PreviewType = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop',
  Responsive: 'responsive',
}

export default PreviewType
